module.exports = __webpack_public_path__ + "media/b_bpair_win.1486ef62.mp3";